import React from 'react';

import { IntroScreen } from '../../Screens';

const IntroContainer = () => {
  return <IntroScreen />;
};
export default IntroContainer;
